import { combineReducers } from 'redux';
import meetingRoomReducer from './meetingRoom';
import groupsReducer from './group';
import organisationsReducer from './organisation';
import usersReducer from './usersReducer';
import waitingAreaReducer from './waitingArea';
import globalMessageReducer from './globalMessage';
import navigationBarReducer from './navigationBar';
import quickViewReducer from './quickView';
import portalSettingReducer from './portalSetting';
import modalReducer from './modal';
import reportReducer from './report';
import { USER_IS_LOGGED_OUT } from '../actions/user.js';
import sharedReducer from './shared';

const rootReducer = (state, action) => {
  if (action.type === USER_IS_LOGGED_OUT) {
    //if user is logged out, set state to undefined. and then call the combine reducer. when stat is undefined, stat is defaulted to initial state.
    state = undefined;
  }
  return appReducer(state, action);
};
const appReducer = combineReducers({
  sharedReducer,
  meetingRoomReducer,
  groupsReducer,
  usersReducer,
  waitingAreaReducer,
  globalMessageReducer,
  navigationBarReducer,
  quickViewReducer,
  organisationsReducer,
  portalSettingReducer,
  modalReducer,
  reportReducer,
});

export default rootReducer;
